
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqkTyfM4V6Avpuwz6nzbOtiaq_45GXgDbeBkcduybwaLhA4Meta } from "/codebuild/output/src1410248601/src/src/pages/faq.vue?macro=true";
import { default as menuSXcDM4iiNi1GYjcpf24DdOgGJxWd_45HA3aYTWb8BVwm8Meta } from "/codebuild/output/src1410248601/src/src/pages/menu.vue?macro=true";
import { default as indexLb9Myx5aYdJw_e15Q_45u6pZl4ph4idyd5HYCiGweXjPUMeta } from "/codebuild/output/src1410248601/src/src/pages/index.vue?macro=true";
import { default as contactmddRPxzM0cvhMHBfXPBCTyC0N00JAQHlm68rlY85lnMMeta } from "/codebuild/output/src1410248601/src/src/pages/contact.vue?macro=true";
import { default as tutorialB0E62tzfn8dIfI_jbvmNyM3rKXsMbEvyxIbn_Jv3tdcMeta } from "/codebuild/output/src1410248601/src/src/pages/tutorial.vue?macro=true";
import { default as agreement_45vgSQGYG4KPy64ieIZJR6Ewfh65hoM7elf76TXbQFVsMeta } from "/codebuild/output/src1410248601/src/src/pages/agreement.vue?macro=true";
import { default as about_45passSQt5ocyuSkSshGmwk3wkm5YAr5_45d_SJglHaCP0sB_ZcMeta } from "/codebuild/output/src1410248601/src/src/pages/about-pass.vue?macro=true";
import { default as index1XXKGjvl_8XWBPZfR0JyKD_45yv5Bfcow4BwJJDlpcaRwMeta } from "/codebuild/output/src1410248601/src/src/pages/card/index.vue?macro=true";
import { default as _91id_933MXVp2R6GEAe_SrNJx_457vjwtkQxt5AG6SWA2Mq17kb8Meta } from "/codebuild/output/src1410248601/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancec1SDkN98qYzWvfpHHeMab6buzbPTbt3eJTFo4aViEXUMeta } from "/codebuild/output/src1410248601/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93mU8t6zamm3X9BH5MCmnvVzS5M5ruhk9LWGyA2_45bapB8Meta } from "/codebuild/output/src1410248601/src/src/pages/notice/[id].vue?macro=true";
import { default as indexkzUXUl3dwSfbkbn7VIFADsjAspJaBEGbAMyBywUYdrYMeta } from "/codebuild/output/src1410248601/src/src/pages/coupon/index.vue?macro=true";
import { default as indexcv5Gb_45LNUSqI52AMZOnIMkUNk6Kh0xiDHghoI1pnUuQMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/index.vue?macro=true";
import { default as indexIap40Wa_45imcwtk2Ps56gfVh_tbL_45cwwb4pUtDNVUYXUMeta } from "/codebuild/output/src1410248601/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93t9Jrgzgx_45igE9HkcbqvVGNFYftryNZFRTpjICJMK_vQMeta } from "/codebuild/output/src1410248601/src/src/pages/parking/[id].vue?macro=true";
import { default as indexK4BDmvYerwkO91goYsgodP3m0K_45L48SKZT5pG4NlP04Meta } from "/codebuild/output/src1410248601/src/src/pages/history/index.vue?macro=true";
import { default as indexiGVdedZjQr18ygbWbkA6S3IWugGlJHrw4JP67NI9PHsMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/index.vue?macro=true";
import { default as index94_45017DIMtwXgRFtqyJKYHZyYFYW5bIHP6L5Co2Pn8wMeta } from "/codebuild/output/src1410248601/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexCR10mz8IqVyq_45xFzMgrifCLmNFi4xwXYgf_45e7mkSP2cMeta } from "/codebuild/output/src1410248601/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviIawMEtdUn4tsHd_45_9d7Jli9dG6mUiC54TCXtf3UNuW8Meta } from "/codebuild/output/src1410248601/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit5zumktfsOtjlFYyuDKu6o_45xphm_hU5dBxoye0Ufv_45_45QMeta } from "/codebuild/output/src1410248601/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement3fdzYKzq1dtYNqBrr_4D8DfaxTKkT73sAL0z2zNz5E8Meta } from "/codebuild/output/src1410248601/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexbiq43LEKjySGkRXI1M19heuKCpzaW_wc_45k46fyrKs04Meta } from "/codebuild/output/src1410248601/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dt78z6FHntgev1J_XIJc9zZ0tt57P9t6DM4UyWdIN8KYMeta } from "/codebuild/output/src1410248601/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmpU2Sz_juKnCjGTiJL0BGV8yuxMUmddd_45gZM7ZZkp_45r8Meta } from "/codebuild/output/src1410248601/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexXMcfpVtWHQQTvEu8PQtuKZmnyBSLf4kaHfn7UEX2do0Meta } from "/codebuild/output/src1410248601/src/src/pages/card/create/index.vue?macro=true";
import { default as index0lM_456Bio7e0FY4j3OdrucpFn_oxNF43x8RLh97n9NUcMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmn3LpTw4BlEMRlwpCtGfhkubXM4_jSMlAdvtqFbBwY_UMeta } from "/codebuild/output/src1410248601/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmNqCTZb6TcMqUp1x1eLhD2hVgYBJYXnBnWZCoCmVicocMeta } from "/codebuild/output/src1410248601/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeDuT_gRJltfHFU4MZ2NZoix3kA_lz62gqEEl6MdiYKskMeta } from "/codebuild/output/src1410248601/src/src/pages/membership/complete.vue?macro=true";
import { default as registerSdyassT0M2nwgxrVklRuClulxBHaS7SsauPtF1pjMkEMeta } from "/codebuild/output/src1410248601/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93r2kiWmoTFHL0IREiwGpZKs8ES6_45tolH_8hRlGDWN0k4Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmOOyPoJ_DUUHX1tst4Vlj_3EIpA_OFZu3OZTeutlv3_454Meta } from "/codebuild/output/src1410248601/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93sr_45UITtLuDEajM66qsiOAwQ8MYKIsPNbQsJzOxxDmOEMeta } from "/codebuild/output/src1410248601/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexGknRZacCfid3Om03_45s8rynlxGKHbZcuVDLmqciswLuYMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45code4fbTpTpo9sLuc38f_rHuO12g9CJLatFXkgJ4OMpmGHcMeta } from "/codebuild/output/src1410248601/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codehtH58pEWo6BwAgN5S1EhQwzGE1FUiElWFz4dA7gsdosMeta } from "/codebuild/output/src1410248601/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeLky1wd4LIJjm6JeI7LJqSYwck1maeEukTrx2qvzoBIsMeta } from "/codebuild/output/src1410248601/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeraKb_1MhkYc0aXZMIB36VkgByiAIcEH4mAie_bLA8ZSUMeta } from "/codebuild/output/src1410248601/src/src/pages/contact-form/register.vue?macro=true";
import { default as completezmO0in5vQSG0Piui_454gPGz7fircFPgX0VGJl7di6XJ4Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexOWvXXFmeJWfW6uABwHLjG8CqMLB9zgtyjw6_455n2h_fIMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm_XbH2l651uC0wvUnCMfgY5zjevsozollAsOda_B3gwQMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completekYWXSnlJk1hDmDfJiP9vsmhtqlneuaHyOP34K2kiVLUMeta } from "/codebuild/output/src1410248601/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index0VYsVfQOhIOX1Iy4kKxByjdsXq4dW4z1dd6MRYTFKCUMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93UUOh0TGz_SfirM9VkxCr_HvnQKTStbc_45dtmGLOLwt3oMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete4r5WCaNjwQMG91dvnoDBb5cJ73UYPVCEToGOnh0qEpcMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasrr6KzbL2w3XCSgjCAIfJjXkFAJPwGQjfyEVl5ZHP3_45YMeta } from "/codebuild/output/src1410248601/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleVY0aa1jMfGG3zbVEK3pFq7O7J0bdQM8cqtF2eR0rkN4Meta } from "/codebuild/output/src1410248601/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailr4ScP_45jxmFnvwVJsmkwquIcqw6C8aaF4HDcYrTYXuggMeta } from "/codebuild/output/src1410248601/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmF6fsFs_n_45ilRBkvwrRQj8aNdkynF6oDGXjnwvbN1g8sMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentEg4GqPPrT_hCYofre_45J1QRZNCrU8281fGLlxUPe_TDAMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmNcMpYYrKmTR_BWbZLGxiOaAk3ci8LAjc5yGksh4fsOAMeta } from "/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateh7R5QPzoo8VmjpFmFRnN0rPiWv5913Tx26fuKHKA0Z4Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeBfr1mv8LP23s2W4_aEyBbUXzIToNmRnL2QoFFr_rYcQMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codele1aOF_uOVPH2Xji2ls9aDxFlFu7eGckBOIyD9w1qdsMeta } from "/codebuild/output/src1410248601/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordlV0JE_451bIRTZswmXfMhHC0ymd0Any_8h2veszbenM1gMeta } from "/codebuild/output/src1410248601/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasvSKzuJdFB0hJFTUyqtVi7I1ZcXvS_yDIp8YKDYc5takMeta } from "/codebuild/output/src1410248601/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register2SvIqI_1dEv_oVEY_fdv_45lQ_451PuMK8UI8kMcgTnf7KAMeta } from "/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45coderYo__45Br_PqrAcjWPo0uxJg9AHZXS_45O2ojLJY8LHvYx4Meta } from "/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexNepq5_DRWGqUYFzWWebXL4cvOKjZdYgl6dVb_45vYkq6IMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexvekKtN_450JzkvAnJNpl8XHiuGFTAgR3lMm93qW6iAhSoMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexlnAeFKlIlMpJ6nG2VNQ7UKhJqjx_oHk7YoK5OdOh2pYMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexAP06ERxiw4yJJYfvnoGKMJf_TSAdHPyLNpmoK1YFxzsMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update50MINttU23V_cosTD5_T1RpQX1Zi_45chP0k4d53709eUMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeHEjILb4QArdqTIsgX2eCpO04HcAX_45QIxGZWuWyDvnjIMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmbnMJBB30nA5Imy5l45eehEDZquhPsqzxAgjg6VWAPL4Meta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexua3NXJoa5KQIyiPryiJHYi84XprC8FzbT3BvL5cdBp0Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete8qgD_RRAHhkFkaxal9mpSHDuab3Uyv20M1SDN2MlMZYMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateRzYZhvHnPHX6FUg1g7F221bYfGN3xU77XvBJGGnDgvcMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexTEzdB33F32OGEiHaoWw_QBFXy7EJBwJBeZ5UhVGLar4Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index4mDzTbLoZ9Qperq5grR8gCbRvhO6Xgo7eyS45q8iXiMMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeMWsfOmy4I8P9z77iVJ9Bw9N8kaTRCFuCvjeqUVoYEo8Meta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexuiPlrehj6ejgtvRMdYwleeukMIYOZppiyQ4JJz36ePwMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45code4UftzMtkdFyO6s_U8e8IvLE7tf5RdmwohUSicRfW9BQMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexdyd5cqKU_45xxDKRMDCb4_D01yBe7H9qotGTREvPu8PhAMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexKBWm_y_h0zNoK5HLY4UoI2egyuZSXcx_45pVgA_457JugdsMeta } from "/codebuild/output/src1410248601/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexUsaJHwYoyDmwsnLmCDEpl80DZh7drHMV7GFxodrHtp4Meta } from "/codebuild/output/src1410248601/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatee_LMi_QqJ5xuccPsMaao8dfXLKrAZ_45Va59V9wPHzOSwMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmshuPO6e7_45kUjx3VLAYy05MkddTOMXkqs_45GgXcTR_tEYMeta } from "/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuSXcDM4iiNi1GYjcpf24DdOgGJxWd_45HA3aYTWb8BVwm8Meta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexLb9Myx5aYdJw_e15Q_45u6pZl4ph4idyd5HYCiGweXjPUMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexkzUXUl3dwSfbkbn7VIFADsjAspJaBEGbAMyBywUYdrYMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexK4BDmvYerwkO91goYsgodP3m0K_45L48SKZT5pG4NlP04Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index94_45017DIMtwXgRFtqyJKYHZyYFYW5bIHP6L5Co2Pn8wMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexCR10mz8IqVyq_45xFzMgrifCLmNFi4xwXYgf_45e7mkSP2cMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexXMcfpVtWHQQTvEu8PQtuKZmnyBSLf4kaHfn7UEX2do0Meta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmn3LpTw4BlEMRlwpCtGfhkubXM4_jSMlAdvtqFbBwY_UMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmNqCTZb6TcMqUp1x1eLhD2hVgYBJYXnBnWZCoCmVicocMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeDuT_gRJltfHFU4MZ2NZoix3kA_lz62gqEEl6MdiYKskMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerSdyassT0M2nwgxrVklRuClulxBHaS7SsauPtF1pjMkEMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmOOyPoJ_DUUHX1tst4Vlj_3EIpA_OFZu3OZTeutlv3_454Meta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45code4fbTpTpo9sLuc38f_rHuO12g9CJLatFXkgJ4OMpmGHcMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codehtH58pEWo6BwAgN5S1EhQwzGE1FUiElWFz4dA7gsdosMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeLky1wd4LIJjm6JeI7LJqSYwck1maeEukTrx2qvzoBIsMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeraKb_1MhkYc0aXZMIB36VkgByiAIcEH4mAie_bLA8ZSUMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm_XbH2l651uC0wvUnCMfgY5zjevsozollAsOda_B3gwQMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completekYWXSnlJk1hDmDfJiP9vsmhtqlneuaHyOP34K2kiVLUMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index0VYsVfQOhIOX1Iy4kKxByjdsXq4dW4z1dd6MRYTFKCUMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete4r5WCaNjwQMG91dvnoDBb5cJ73UYPVCEToGOnh0qEpcMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleVY0aa1jMfGG3zbVEK3pFq7O7J0bdQM8cqtF2eR0rkN4Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailr4ScP_45jxmFnvwVJsmkwquIcqw6C8aaF4HDcYrTYXuggMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmF6fsFs_n_45ilRBkvwrRQj8aNdkynF6oDGXjnwvbN1g8sMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentEg4GqPPrT_hCYofre_45J1QRZNCrU8281fGLlxUPe_TDAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmNcMpYYrKmTR_BWbZLGxiOaAk3ci8LAjc5yGksh4fsOAMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeBfr1mv8LP23s2W4_aEyBbUXzIToNmRnL2QoFFr_rYcQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codele1aOF_uOVPH2Xji2ls9aDxFlFu7eGckBOIyD9w1qdsMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordlV0JE_451bIRTZswmXfMhHC0ymd0Any_8h2veszbenM1gMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register2SvIqI_1dEv_oVEY_fdv_45lQ_451PuMK8UI8kMcgTnf7KAMeta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45coderYo__45Br_PqrAcjWPo0uxJg9AHZXS_45O2ojLJY8LHvYx4Meta || {},
    component: () => import("/codebuild/output/src1410248601/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1410248601/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]